import { observeElement } from '@uvocore-front/utils';
import '../../theme/DefaultTheme';

import '../../components/Header/main';
import '../../components/Calculator/default';
import '../../components/Footer';
import { getHTML, fetch } from '../../utils';
import { PriceTable, PriceTableSelect } from '../../components/PriceTable';

document.addEventListener('DOMContentLoaded', () => {
  const pricingContainer = document.querySelector('[data-pricing-table]');
  if (pricingContainer) {
    const siteId = pricingContainer.getAttribute('data-pricing-table');
    getHTML(`/assets/get_pricing_block/?siteId=${siteId}&format=json`).then(response => {
      const calcData = JSON.parse(response);
      PriceTable(calcData).then(table => {
        PriceTableSelect({
          calcData,
          selectClassName: 'Select',
        });
        pricingContainer.removeChild(pricingContainer.querySelector('.Loader'));
        pricingContainer.appendChild(table);
      });
    });
  }

  observeElement({
    element: '.pricing-table-info__vat-link',
    marginValue: 200,
    callback: () => {
      const vatLink = document.querySelector('.pricing-table-info__vat-link');
      const vatLinkClose = document.querySelector('.prices-vat-rates__close');
      const vatBlock = document.querySelector('.prices-vat-rates');

      fetch('/api/config/getVatForCountries.json')
        .then(response => response.json())
        .then(({ success, vats }) => {
          if (!success) return false;
          const vatTable = vatBlock.querySelector('.prices-vat-rates__table');
          const sortedArray = vats
            .filter(item => item.tax > 0)
            .sort((a, b) => {
              const countryA = a.country.toUpperCase();
              const countryB = b.country.toUpperCase();
              if (countryA < countryB) return -1;
              if (countryA > countryB) return 1;
              return 0;
            });
          return sortedArray.forEach(({ country, tax }) => {
            const tr = document.createElement('tr');
            const td1 = document.createElement('td');
            const td2 = document.createElement('td');
            td1.innerText = country;
            td2.innerText = `${tax}%`;
            tr.appendChild(td1);
            tr.appendChild(td2);
            vatTable.appendChild(tr);
          });
        })
        .catch(({ error }) => console.error(error));

      vatLink.addEventListener('click', () => {
        vatBlock.classList.add('prices-vat-rates--show');
      });

      vatLinkClose.addEventListener('click', () => {
        vatBlock.classList.remove('prices-vat-rates--show');
      });
    },
  });
});
